import inclusionApi from "@/services/api/inclusionApi";
import {
  CreateInclusionInterface,
  inclusionDefault,
  InclusionInterface,
  QueryInclusionInterface,
  UpdateInclusionInterface,
} from "@/types/InclusionInterface";
import { reactive } from "vue";
import { Module } from "vuex";

const state = reactive({
  ...inclusionDefault,
  selectedInclusionId: null as string | null,
});

export type inclusionState = typeof state;

const inclusionStore: Module<inclusionState, never> = {
  namespaced: true,
  state,
  mutations: {
    updateSelectedInclusionId(state, inclusionId: string) {
      state.selectedInclusionId = inclusionId;
    },
  },
  getters: {
    selectedInclusionId: (state) => state.selectedInclusionId,
  },
  actions: {
    createInclusion(
      _,
      params: CreateInclusionInterface
    ): Promise<InclusionInterface> {
      return inclusionApi.createInclusion(params);
    },
    getInclusionsByQuery(_, params: QueryInclusionInterface) {
      return inclusionApi.getInclusionsByQuery(params);
    },
    updateInclusion(_, params: { dto: UpdateInclusionInterface; id: string }) {
      return inclusionApi.updateInclusion(params.dto, params.id);
    },
    deleteInclusion(_, params: { id: string }) {
      return inclusionApi.deleteInclusion(params.id);
    },
    uploadImage(_, params: { builderId: string; image: FormData }) {
      return inclusionApi.uploadImageInclusion(params.builderId, params.image);
    },
  },
};

export default inclusionStore;
